module.exports = __webpack_public_path__ + "img/about-us1.98dc72d3.jpg";